import { useEffect, useContext } from 'react';
import { navigate } from '@reach/router';
import { AuthContext } from "../helpers/AuthContext";

// No goodbye screen — sign out and redirect immediately. logout() clears
// state + localStorage; we navigate to /login in the same tick. Empty dep
// array so it runs exactly once (the old version had no deps and also sat
// on a 3s timer before doing anything).
const Logout = () => {
    const context = useContext(AuthContext);

    useEffect(() => {
        context.logout();
        navigate('/login');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return null;
};

export default Logout;
